import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tile-list',
    templateUrl: './tile-list.component.html',
    styleUrls: ['./tile-list.component.css']
})
export class TileListComponent implements OnInit {
    tiles = [
        { title: 'Tile 1', description: 'Descrizione della tile 1', image: './assets/images/alumni.png' },
        { title: 'Tile 2', description: 'Descrizione della tile 2', image: 'https://via.placeholder.com/200' },
        { title: 'Tile 3', description: 'Descrizione della tile 3', image: 'https://via.placeholder.com/200' },
        { title: 'Tile 4', description: 'Descrizione della tile 4', image: 'https://via.placeholder.com/200' }
    ];

    categories = ['Categoria 1', 'Categoria 2', 'Categoria 3', 'Categoria 4', 'Categoria 5', 'Categoria 6'];

    constructor() { }

    ngOnInit(): void { }

    searchText: string = '';
    filteredTiles = [...this.tiles];
    filterTiles(): void {
        this.filteredTiles = this.tiles.filter(tile =>
            tile.title.toLowerCase().includes(this.searchText.toLowerCase()) ||
            tile.description.toLowerCase().includes(this.searchText.toLowerCase())
        );
    }
    


  

}